import React, { useEffect } from 'react';
import Downloads from './Donwload/Downloads';
import Guide from './Donwload/Guide';
import styles from '../css/download.module.css'
import { useNavigate, useParams } from 'react-router-dom';


const Download = () => {

  // const [selecteddownload, setSelectedDownload] = useState('download');

  // const handleDownloadClick = (download) => {
  //   setSelectedDownload(download);
  // };
  const { category } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!category) {
      navigate('/download/1'); // 기본 경로로 리디렉션
    }
  }, [category, navigate]);

  const handleDownloadClick = (download) => {
    navigate(`/download/${download}`);
  };
  return (
    <div>
      <div id={styles.sub_top_warp}>
        <div className={styles.sub_top}>
          <p className={styles.sub_top_text01}>다운로드</p>
        </div>
      </div>



      <div id={styles.sub_con_warp}>
        <div className={styles.sub_menu}>
          <div
            className={styles.sub_menu_pad}
            style={{ background: category === '1' ? "#000" : "#fff", color: category === '1' ? "#fff" : "#000" }}
            onClick={() => handleDownloadClick('1')}
          >
            다운로드
          </div>
          <div
            className={styles.sub_menu_pad}
            style={{ background: category === '2' ? "#000" : "#fff", color: category === '2' ? "#fff" : "#000" }}
            onClick={() => handleDownloadClick('2')}
          >
            설치 가이드
          </div>
        </div>

        <div className={styles.sub_title}>
          {category === '1' && <p className={styles.sub_title_text01}>다운로드</p>}
          {category === '2' && <p className={styles.sub_title_text01}>설치 가이드</p>}
        </div>

        {category === '1' && <Downloads />}
        {category === '2' && <Guide />}

      </div>
      <div style={{ clear: 'both', height: 80 }}></div>
    </div>
  );
}

export default Download;
